function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useMemo, useState } from 'react';
import { injectIntl } from 'react-intl';
import compose from '../../../utils/compose';
import normalizeLocaleData from '../../../utils/i18n/normalizeLocaleData';
import RecordEditorTitleField from '../RecordEditorTitleField/RecordEditorTitleField';
import ValidationForm from '../../ValidationForm/ValidationForm';
import CheckboxesWidget from '../../Widgets/CheckboxesWidget';
import FileWidget from '../../Widgets/FileWidget/FileWidget';
import wrapTriggerFieldWidget from '../../Widgets/wrapTriggerFieldWidget';
import FilterSelectWidget from '../../Widgets/FilterSelectWidget';
import FormDataChangeWrapper from '../../FormDataChangeWrapper/FormDataChangeWrapper';
import RichtextWidget from '../../Widgets/RichtextWidget';
import RECORD_EDITOR_FROALA_CONFIG from '../Widgets/recordEditorFroalaConfig';
import froalaConverter from '../../../utils/froalaConverter';
import RecordEditorGroupTemplate from '../RecordEditorGroupTemplate';
import TextAreaWidget from '../../Widgets/TextareaWidget';
import TextWidget from '../../Widgets/TextWidget';
import en from './locales/RecordEditorForm.en.json';
import getTransformErrors from './getRecordEditorTransformErrors';
import withDebounceValue from '../../../Inputs/withDebounceValue/withDebounceValue';
import { withAdditionalIntl } from '../../../I18n/AdditionalIntl/AdditionalIntl';
import { withFormFiles } from '../../Widgets/FileWidget/FilesContext';
// @ts-ignore
var messages = normalizeLocaleData(en, '@dm/components.recordEditorForm');
var ALLOWED_TAGS = ['strong', 'b', 'em', 'i', 'u', 'sup', 'sub', 'br'];
export var getRecordEditorWidgets = function getRecordEditorWidgets(triggerData) {
  return {
    checkboxes: function checkboxes(props) {
      return /*#__PURE__*/React.createElement(CheckboxesWidget, Object.assign({
        scroll: props.options.enumOptions.length > 7,
        scrollHeight: "150px"
      }, props));
    },
    file: function file(props) {
      return /*#__PURE__*/React.createElement(FileWidget, Object.assign({
        maxFileNameLength: 140,
        maxFileSize: 1024
      }, props));
    },
    select: wrapTriggerFieldWidget(FilterSelectWidget, FilterSelectWidget, triggerData),
    // @ts-ignore
    text: withDebounceValue({})(TextWidget),
    // @ts-ignore
    textarea: withDebounceValue({})(TextAreaWidget),
    richtext: function richtext(props) {
      return /*#__PURE__*/React.createElement(RichtextWidget, Object.assign({
        config: RECORD_EDITOR_FROALA_CONFIG
      }, props));
    }
  };
};
var RecordEditorFields = {
  TitleField: RecordEditorTitleField
};
var RecordEditorForm = function RecordEditorForm(_ref) {
  var fields = _ref.fields,
    _ref$indentFields = _ref.indentFields,
    indentFields = _ref$indentFields === void 0 ? false : _ref$indentFields,
    widgets = _ref.widgets,
    schema = _ref.schema,
    uiSchema = _ref.uiSchema,
    formData = _ref.formData,
    triggerData = _ref.triggerData,
    onChange = _ref.onChange,
    intl = _ref.intl,
    transformErrors = _ref.transformErrors,
    _ref$view = _ref.view,
    view = _ref$view === void 0 ? 'DEFAULT' : _ref$view,
    _ref$lazyLoadDSA = _ref.lazyLoadDSA,
    lazyLoadDSA = _ref$lazyLoadDSA === void 0 ? true : _ref$lazyLoadDSA,
    rest = _objectWithoutProperties(_ref, ["fields", "indentFields", "widgets", "schema", "uiSchema", "formData", "triggerData", "onChange", "intl", "transformErrors", "view", "lazyLoadDSA"]);
  var _widgets = useMemo(function () {
    return Object.assign({}, getRecordEditorWidgets(triggerData), widgets);
  }, [widgets, triggerData]);
  var _fields = useMemo(function () {
    return Object.assign({}, RecordEditorFields, fields);
  }, [fields]);
  var _transformErrors = useMemo(function () {
    return transformErrors || getTransformErrors(intl, schema, uiSchema);
  }, [transformErrors, intl, schema, uiSchema]);
  var formContext = useMemo(function () {
    return {
      lazyLoadDSA: lazyLoadDSA
    };
  }, [lazyLoadDSA]);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    onLoad = _useState2[0],
    setOnLoad = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    newFormData = _useState4[0],
    setNewFormData = _useState4[1];
  useMemo(function () {
    if (onLoad && formData) {
      setNewFormData(Object.keys(formData).reduce(function (acc, key, index) {
        if (uiSchema && uiSchema[key] && uiSchema[key]['ui:widget'] === 'richtext') {
          acc[key] = froalaConverter.stripTags.apply(froalaConverter, [
          // @ts-ignore
          froalaConverter.fromFroala(formData[key], uiSchema[key])].concat(ALLOWED_TAGS));
        } else {
          if (typeof formData[key] === 'string') {
            acc[key] = froalaConverter.stripTags.apply(froalaConverter, [formData[key]].concat(ALLOWED_TAGS));
          } else {
            acc[key] = formData[key];
          }
        }
        return acc;
      }, {}));
      setOnLoad(false);
    } else if (formData) {
      // @ts-ignore
      setNewFormData(formData);
    }
  }, [formData]);
  return /*#__PURE__*/React.createElement(FormDataChangeWrapper, {
    formData: newFormData,
    onChange: onChange,
    schema: schema
  }, /*#__PURE__*/React.createElement(ValidationForm, Object.assign({
    GroupTemplate: RecordEditorGroupTemplate,
    fields: _fields,
    indentFields: indentFields,
    formContext: formContext,
    widgets: _widgets,
    schema: schema,
    uiSchema: uiSchema,
    formData: newFormData,
    onChange: onChange,
    transformErrors: _transformErrors,
    view: view
  }, rest)));
};
export default compose(withFormFiles, withAdditionalIntl({
  messages: messages,
  path: '_PROPOSED_/RecordEditorForm/RecordEditorForm/locales/RecordEditorForm',
  namespace: '@dm/components.recordEditorForm'
}), injectIntl)(RecordEditorForm);